import React from "react";
import { useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import {
  adminRoutes,
  governorRoutes,
  groupLeaderRoutes,
  publicRoutes,
  supervisorRoutes,
  groupSecretaryRoutes,
  supervisorLeaderRoutes,
} from 'routes/routes';

const routes = {
  supervisor: supervisorRoutes,
  supervisorleader: supervisorLeaderRoutes,
  governor: governorRoutes,
  groupleader: groupLeaderRoutes,
  admin: adminRoutes,
  groupadmin: groupSecretaryRoutes,
  regionsupervisor: supervisorRoutes,
};

const App = () => {
  const { role, token } = useSelector((state) => state.authReducer);
  const content = useRoutes(token ? routes[role] : publicRoutes);
  return <>{content}</>;
};

export default React.memo(App);
